// Private storage helpers — extracted verbatim from partners-portal.jsx.
// Both `teasers` and `investor-decks` buckets are private. Public URLs stored in
// the DB return 400 on direct fetch; the frontend must request a 15-min signed
// URL from the `signed-file-url` Edge Function before opening any file.
//
// parseStorageUrl handles both legacy (.../object/public/...) and new
// (.../object/sign/...) URL shapes, plus bare bucket/path strings.

export const parseStorageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const m = url.match(/\/storage\/v1\/object\/(?:public\/|sign\/)?([^/]+)\/([^?]+)/);
  if (!m) return null;
  return { bucket: m[1], path: decodeURIComponent(m[2]) };
};

// Fetch a short-lived signed URL for any stored bucket file. Throws on
// auth/authz/network failure. Caller decides how to surface the error.
export const getSignedFileUrl = async (storedUrl) => {
  const parsed = parseStorageUrl(storedUrl);
  if (!parsed) throw new Error('Not a recognised storage URL');
  const { invokeFunction } = await import('../supabaseClient');
  const { data, error } = await invokeFunction('signed-file-url', {
    body: { bucket: parsed.bucket, path: parsed.path }
  });
  if (error) throw new Error(error.message || 'Failed to sign URL');
  if (data?.error) throw new Error(data.error);
  if (!data?.url) throw new Error('No URL returned');
  return data.url;
};

// Open any stored bucket file in a new tab via the signed-URL flow.
// Use this for any UI that previously did <a href={storedUrl} target="_blank">.
export const openSignedFile = async (storedUrl) => {
  try {
    const signed = await getSignedFileUrl(storedUrl);
    window.open(signed, '_blank', 'noopener,noreferrer');
  } catch (e) {
    window.alert('Failed to open file: ' + e.message);
  }
};
